import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import CardContent from '@material-ui/core/CardContent';

import { tabletUp } from 'styles/utils';

const cardContentCss = css`
  &.MuiCardContent-root {
    display: flex;
    flex-direction: column;
    min-height: 117px;

    ${tabletUp} {
      padding: 15px 23px;
    }
  }
`;
function PromoContent({ children, className }) {
  return (
    <CardContent className={className} css={cardContentCss}>
      {children}
    </CardContent>
  );
}

PromoContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PromoContent;
